import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalize',
})
export class CapitalizePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';

    // Convierte la primera letra a mayúscula y el resto a minúscula
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }
}
